import type { HubBomLine } from "./assemblyApi";

export interface AssemblyComponentSwapSlot {
  id: string;
  label: string;
  variable_names: string[];
}

export function assemblySwapSlotIsChecked(
  swappedVariableNames: ReadonlySet<string>,
  variableNames: readonly string[],
): boolean {
  return variableNames.length > 0 && variableNames.every((name) => swappedVariableNames.has(name));
}

export function assemblySwapSlotSkuSummary(
  lines: readonly HubBomLine[],
  variableNames: readonly string[],
): string {
  const skus = variableNames
    .map((variableName) => lines.find((line) => line.variable_name === variableName)?.component_sku?.trim() ?? "")
    .filter((sku) => sku !== "");
  if (skus.length === 0) return "—";
  return [...new Set(skus)].join(" · ");
}

export function toggleAssemblySwapSlotVariables(
  current: ReadonlySet<string>,
  variableNames: readonly string[],
): Set<string> {
  const next = new Set(current);
  const allChecked = assemblySwapSlotIsChecked(current, variableNames);
  if (allChecked) {
    for (const variableName of variableNames) {
      next.delete(variableName);
    }
  } else {
    for (const variableName of variableNames) {
      next.add(variableName);
    }
  }
  return next;
}
